import type { TOC } from '@ember/component/template-only';

import eq from 'webapp/helpers/eq';
import FormRadiobutton from 'webapp/components/form/radiobutton';
import FormRadiobuttonSingle from 'webapp/components/form/radiobutton-single';

export interface SheetColumnOption extends LabelValuePairString {
	label2: string; // "Column X" when the column has a title
	type: string;
	typeText: string;
	isRecommended: boolean;
	isDisabled: boolean;
}

interface CustomQuerySetupWizardSheetColumnPickerComponentInterface {
	Args: {
		options: SheetColumnOption[];
		selected: string;
		isNoneShown: boolean;
		isNoneDisabled: boolean;
		noneDisabledText: string;
		optionNoneLabel: string;
		select: (columnId: AnySimpleValue) => void;
	};
}

const CustomQuerySetupWizardSheetColumnPickerComponent: TOC<CustomQuerySetupWizardSheetColumnPickerComponentInterface> =
	<template>
		<div class="column-table">

			<table width="100%" cellspacing="0" cellpadding="0">
				<colgroup>
					<col />
					<col width="150" />
					<col width="150" />
				</colgroup>
				<tbody>
					{{#each @options as |option|}}
						<tr
							class="{{if (eq option.value @selected) 'selected'}}
								{{if option.isDisabled 'disabled'}}"
						>

							<td class="c1">
								<div class="radio radiobutton-default">
									<div class="radiobutton-default size-normal">
										<span class="radiobutton size-normal val-default">
											<FormRadiobuttonSingle
												@id="column-{{option.value}}-id"
												@name="column-{{option.value}}-name"
												@selected={{@selected}}
												@value={{option.value}}
												@isDisabled={{option.isDisabled}}
												@onChange={{@select}}
											/>
											<label for="column-{{option.value}}-id">
												{{option.label}}
											</label>
										</span>
									</div>
								</div>
							</td>

							<td class="c2">
								<div>
									<label for="column-{{option.value}}-id">
										{{option.label2}}&nbsp;
									</label>
								</div>
							</td>

							<td class="c3">
								<div>
									<label for="column-{{option.value}}-id">
										<span class="col-badge col-badge--{{option.type}}">
											{{option.typeText}}
										</span>
									</label>
								</div>
							</td>
						</tr>
					{{/each}}
				</tbody>
			</table>

			{{#if @isNoneShown}}
				<div class="c1">
					<div class="radio radiobutton-default">
						<FormRadiobutton
							@name="column"
							@selected={{@selected}}
							@value=""
							@label={{@optionNoneLabel}}
							@onChange={{@select}}
							@isDisabled={{@isNoneDisabled}}
							@tooltipText={{@noneDisabledText}}
						/>
					</div>
				</div>
			{{/if}}

		</div>
	</template>;

export default CustomQuerySetupWizardSheetColumnPickerComponent;
